import { t } from "@/language/translation";
import { lisaConfirm } from "@fi-solutions/lisa-ui";
import type { ConfirmationOptions } from "primevue/confirmationoptions";

export function confirmModal(options: Partial<ConfirmationOptions> & { showDeleteText?: boolean }) {
  // this async import prevents loading the store before it is initialized
  // TODO remove after LISA3
  import("@/composables/useLISA3").then(({ isLISA3 }) => {
    if (isLISA3.value === true) {
      lisaConfirm({
        title: t("components.ConfirmationModal.title"),
        message:
          options.message ??
          (options.showDeleteText
            ? t("components.ConfirmationModal.deleteText")
            : t("global.cancelMsgBox")),
        cancelLabel: t("components.ConfirmationModal.rejectLabel"),
        confirmLabel: options.showDeleteText ? t("global.delete") : t("global.next"),
        confirmVariant: options.showDeleteText ? "error" : "primary",
      }).then((el) => {
        if (el === "cancel") {
          options.reject?.();
        } else {
          options.accept?.();
        }
      });
    } else {
      window.$confirm?.require({
        header: t("components.ConfirmationModal.title"),
        rejectLabel: t("components.ConfirmationModal.rejectLabel"),
        acceptIcon: options.acceptIcon ?? "fas fa-angle-double-right",
        rejectIcon: options.rejectIcon ?? "fas fa-times",
        acceptLabel: options.showDeleteText ? t("global.delete") : t("global.next"),
        acceptClass: options.showDeleteText ? "p-button-danger" : "",
        rejectClass: "p-button-secondary",
        ...options,
        message:
          options.message ??
          (options.showDeleteText
            ? t("components.ConfirmationModal.deleteText")
            : t("global.cancelMsgBox")),
      });
    }
  });
}
